// 项目级常量
export const DEFAULT_HOME_PATH = '/home';
export const COMPANY_NAME = '';
